
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Init } from './app/app.init';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as Cookies from 'js-cookie';
import constants from './app/shared/constants';
import '@datadog/browser-rum/bundle/datadog-rum';
import '@datadog/browser-logs/bundle/datadog-logs';
const init = new Init();
const jwtHelper = new JwtHelperService();

const getUserId = (): number => {
  const authCookie = Cookies.get(constants.QUESTIONNAIRE_TOKEN);
  let token = {};
  let userId = -1;

  if (authCookie !== undefined)
    token = jwtHelper.decodeToken(authCookie);

  if (token.hasOwnProperty('user_id'))
    userId = token['user_id'];

  return userId;
};

if (environment.production) {
  enableProdMode();
}

declare global {
  interface Window {
    DD_RUM: any;
    DD_LOGS: any;
  }
}

if (environment.ddg_enabled) {
  window.DD_RUM.init({
    applicationId: 'b834e83f-90b8-4918-a52f-c224e55f115a',
    clientToken: 'pubf06bc6c0a9b1c89d465fd2ad142b1969',
    site: 'datadoghq.com',
    service: 'questionnaire-xref-com',
    env: environment.env,
    sampleRate: 1,
    sessionReplaySampleRate: 0,
    trackInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [/https:\/\/.*\.xref\.com/, /https:\/\/.*\.xref\.io/]
  });
  window.DD_RUM.startSessionReplayRecording();
}

if (environment.ddg_enabled) {
  window.DD_LOGS.init({
    service: 'questionnaire-xref-com',
    env: environment.env,
    clientToken: 'pubf06bc6c0a9b1c89d465fd2ad142b1969',
    site: 'datadoghq.com',
    forwardErrorsToLogs: true,
    forwardConsoleLogs: "all",
    sampleRate: 100
  });
}


function getEnvironment() {
  if (environment.DOMAIN != 'localhost') {
    const url = window.location.href;
    if (url.includes('dev')) {
      return 'dev';
    }
    if (url.includes('sandbox')) {
      return 'sandbox';
    }
    return 'prod';
  }
}

const bootXref = () => {
  const userId = getUserId();

  init.destroyUnsupportedBrowser();
  init.destroyOverlay();


  platformBrowserDynamic().bootstrapModule(AppModule);
};

if (init.browserSupported) {
  bootXref();

} else {
  init.showUnsupportedBrowser();
  init.hideOverlay();
}
